module.exports = __webpack_public_path__ + "fonts/EBGaramond-Roman-VariableFont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/EBGaramond/EBGaramond-Roman-VariableFont.woff2
// module id = 3489
// module chunks = 0